import bodyTextSvg from './body_text.svg';
import headerLine1Svg from './header_line_1.svg';
import headerLine2Svg from './header_line_2.svg';
import titleTextSvg from './title_text.svg';
import './DialogTexts.css';

/**
 * Figma texts in the dialog window:
 * text_3 «Так держать!», text_2 «теперь твой»,
 * title_text «Залетай каждый день!», text_4 body.
 */
export function DialogTexts() {
  return (
    <>
      <img
        className="daily-strike-texts__header-line-1"
        src={headerLine1Svg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className="daily-strike-texts__header-line-2"
        src={headerLine2Svg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className="daily-strike-texts__title"
        src={titleTextSvg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <img
        className="daily-strike-texts__body"
        src={bodyTextSvg}
        alt=""
        draggable={false}
        aria-hidden
      />
    </>
  );
}
